<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 324 324">
    <defs>
    </defs>
    <title>Coach_Symbol_BlackBG</title>
    <g id="Layer_1" data-name="Layer 1">
      <rect class="cls-1" width="323.99" height="324.01" />
      <path
        class="cls-2"
        d="M274.4,136.67a7.07,7.07,0,0,0,7.07-7.06V57.91c0-.24,0-.47,0-.7s0-.2,0-.3l-.06-.39c0-.11-.06-.23-.09-.34s-.05-.22-.08-.33-.08-.22-.12-.33-.07-.21-.11-.32l-.15-.31c0-.1-.09-.21-.15-.31s-.11-.2-.17-.3l-.18-.3-.24-.32c-.06-.08-.11-.16-.17-.23a7.72,7.72,0,0,0-1-1l-.2-.15-.36-.26-.26-.16-.33-.2-.27-.13-.36-.16a2.5,2.5,0,0,0-.25-.09l-.41-.15-.22,0-.45-.11-.21,0c-.16,0-.31,0-.47-.06h-.22a3.59,3.59,0,0,0-.47,0H206.64a7.07,7.07,0,1,0,0,14.13h50.71L168.7,153.62V108a7.07,7.07,0,0,0-14.13,0v59.72l-39.82,39.82V108a7.06,7.06,0,0,0-14.12,0V221.69L69.75,252.57a52.42,52.42,0,0,1-10.81-31.94V117.71A52.8,52.8,0,0,1,111.68,65h58.88a7.07,7.07,0,0,0,0-14.13H111.68a67,67,0,0,0-66.87,66.87V220.63a66.54,66.54,0,0,0,14.89,42l-15.1,15.1a7.06,7.06,0,0,0,10,10l15.1-15.09a66.51,66.51,0,0,0,42,14.88H214.6a66.94,66.94,0,0,0,66.87-66.86V165.08a7.07,7.07,0,1,0-14.13,0v55.55a52.8,52.8,0,0,1-52.74,52.74H111.68a52.48,52.48,0,0,1-31.94-10.81l30.88-30.88H222.7a7.07,7.07,0,0,0,0-14.13h-98l39.82-39.82H222.7a7.06,7.06,0,1,0,0-14.12h-44L267.34,75v54.66A7.06,7.06,0,0,0,274.4,136.67Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "LogoLarge"
};
</script>

<style scoped>
  .cls-1 {
    fill: #231f20;
  }
  .cls-2 {
    fill: #9dcd5b;
  }
</style>
